import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataType } from '../../../../../../data-type-widgets/data-type/data-type-component';
import { IosNativeSupportSyncService } from './ios-native-support-sync.service';
import { SyncIosNativeSupportResponseDTO } from './ios-native-support-sync.model';
import { MatStepper } from '@angular/material/stepper';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-ios-native-support-sync-modal',
  templateUrl: './ios-native-support-sync-modal.component.html',
  styleUrls: ['./ios-native-support-sync-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class IosNativeSupportSyncModalComponent implements OnInit {
  formGroup: UntypedFormGroup;

  FILE_UPLOAD_TYPE = DataType.file_upload;
  fileConfig = { name: 'filename', label: '', noLabel: true, suffix: '*.csv', type: this.FILE_UPLOAD_TYPE };

  processing = false;
  done = false;
  summary: SyncIosNativeSupportResponseDTO = { add: [], remove: [], notFound: [], allSupported: [] };

  @ViewChild('stepper') stepper: MatStepper;

  resetSubject = new Subject<void>();

  constructor(
    private iosNativeSupportBatchService: IosNativeSupportSyncService,
    private spinner: NgxSpinnerService,
    fb: UntypedFormBuilder
  ) {
    this.formGroup = fb.group({
      filename: [null, Validators.required],
    });
  }

  ngOnInit(): void {}

  processFile(): void {
    this.processing = true;
    this.spinner.show();
    this.iosNativeSupportBatchService.checkIosNativeSupportBatchFile(this.formGroup.value).subscribe({
      next: (next) => {
        this.summary = next;
        this.stepper.next();
        this.spinner.hide();
        this.processing = false;
      },
      error: (err) => {
        this.formGroup.get('filename').setErrors({ checkError: true });
        this.spinner.hide();
        this.processing = false;
      },
    });
  }

  authorise(): void {
    this.spinner.show();
    const add = this.summary.add.map((e) => e.id);
    const remove = this.summary.remove.map((e) => e.id);
    this.iosNativeSupportBatchService.makeIosNativeBatchUpdate({ add, remove }).subscribe({
      next: () => {
        this.done = true;
        this.spinner.hide();
        this.stepper.next();
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }
}
